import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';

/**
 * Plain link which points to the correct status page for HCP in a given environment.
 *
 * ```
 * <Hcp::StatusPageLink />
 * ```
 */
export default class HcpStatusPageLink extends Component {
  @service systemStatus;

  get statusPageUrl() {
    return this.systemStatus.statusPageUrl;
  }
  <template>
    <a
      data-test-hcp-status-page-link
      href={{this.statusPageUrl}}
      rel="noreferrer noopener"
      target="_blank"
    >
      {{t "components.hcp.status-page-link"}}
    </a>
  </template>
}
